/**
 * TagStatus — Figma-aligned story/character status tag.
 *
 * Props:
 *   status — 'unreviewed' | 'practicing' | 'known'
 *   children — optional override label text
 *   style — optional override styles
 */
import { useTranslation } from 'react-i18next';
import s from './TagStatus.module.css';

const STATUS_CONFIG = {
  unreviewed: { color: '#ff6821', labelKey: 'common.unreviewed' },
  unread:     { color: '#f48271', labelKey: 'common.unread' },
  practicing: { color: '#2ab8a8', labelKey: 'common.practicing' },
  known:      { color: '#766855', labelKey: 'common.known' },
};

export default function TagStatus({ status = 'unreviewed', children, style }) {
  const { t } = useTranslation();
  const config = STATUS_CONFIG[status] || STATUS_CONFIG.unreviewed;

  return (
    <span
      className={s.tag}
      style={{ '--tag-color': config.color, ...style }}
    >
      {children || t(config.labelKey)}
    </span>
  );
}
